import SettingLogin from './SettingLogin';

export default SettingLogin;
